import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=31b5ca44"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports